//imgs
import img01 from "../../assets/images/chapters/01/01.jpg";
import img02 from "../../assets/images/chapters/01/02.jpg";
import img03 from "../../assets/images/chapters/01/03.jpg";
import img04 from "../../assets/images/chapters/01/04.jpg";
import img05 from "../../assets/images/chapters/01/05.jpg";
import img06 from "../../assets/images/chapters/01/06.jpg";
import img07 from "../../assets/images/chapters/01/07.jpg";
import img08 from "../../assets/images/chapters/01/08.jpg";
import img09 from "../../assets/images/chapters/01/09.jpg";
import img10 from "../../assets/images/chapters/01/10.jpg";
import img11 from "../../assets/images/chapters/01/11.jpg";
import img12 from "../../assets/images/chapters/01/12.jpg";
import img13 from "../../assets/images/chapters/01/13.jpg";
import img14 from "../../assets/images/chapters/01/14.jpg";
import img15 from "../../assets/images/chapters/01/15.jpg";
import img16 from "../../assets/images/chapters/01/16.jpg";
import img17 from "../../assets/images/chapters/01/17.jpg";
import img18 from "../../assets/images/chapters/01/18.jpg";
import img19 from "../../assets/images/chapters/01/19.jpg";
import img20 from "../../assets/images/chapters/01/20.jpg";
import img21 from "../../assets/images/chapters/01/21.jpg";
import img22 from "../../assets/images/chapters/01/22.jpg";

import { captions, texts } from "../../assets/data/chapters/chapter01";

// pictureReveal
import ScrollReveal from "../scrollReveal";
import ScrollRevealSpan from "../scrollRevealSpan";

const Chapter = () => {
  return (
    <div id="chapter01">
      <ScrollReveal className="group01">
        <div className="title">
          <span>Apollo 11</span>
          <span className="arrow"></span>
          <span>CREW⁂</span>
        </div>

        <div className="informations citation">
          <p>{texts[0]}</p>
        </div>

        <div className="picture grid-col-5">
          <img src={img01} alt="" />
          <p className="caption">{captions[0]}</p>
        </div>
      </ScrollReveal>

      <div className="group03">
        <ScrollRevealSpan className="grid-col-lg">{texts[1]}</ScrollRevealSpan>
        <ScrollReveal className="picture grid-col-sm-5">
          <img src={img02} alt="" />
        </ScrollReveal>
        <ScrollReveal className="picture grid-col-sm">
          <img src={img03} alt="" />
        </ScrollReveal>
        <ScrollRevealSpan className="grid-col-lg">{texts[2]}</ScrollRevealSpan>
        <ScrollRevealSpan className="grid-col-md citation">
          {texts[3]}
        </ScrollRevealSpan>
        <ScrollRevealSpan className="grid-col-lg">{texts[4]}</ScrollRevealSpan>
        <ScrollRevealSpan className="grid-col-lg">{texts[5]}</ScrollRevealSpan>
        <ScrollReveal className="picture grid-col-sm-6">
          <img src={img04} alt="" />
        </ScrollReveal>
        <ScrollRevealSpan className="grid-col-lg">{texts[6]}</ScrollRevealSpan>
        <ScrollReveal className="picture grid-col-sm-5">
          <img src={img05} alt="" />
        </ScrollReveal>
        <ScrollReveal className="picture grid-col-sm">
          <img src={img06} alt="" />
        </ScrollReveal>
        <ScrollRevealSpan className="grid-col-lg">{texts[7]}</ScrollRevealSpan>

        <ScrollReveal className="picture grid-col-5">
          <img src={img07} alt="" />
        </ScrollReveal>

        <ScrollRevealSpan className="grid-col-lg">{texts[8]}</ScrollRevealSpan>

        <ScrollReveal className="picture grid-col-5">
          <img src={img08} alt="" />
        </ScrollReveal>

        <ScrollRevealSpan className="grid-col-lg">{texts[9]}</ScrollRevealSpan>

        <ScrollReveal className="picture grid-col-5">
          <img src={img09} alt="" />
        </ScrollReveal>

        <ScrollRevealSpan className="grid-col-lg">{texts[10]}</ScrollRevealSpan>
        <ScrollRevealSpan className="grid-col-md citation">
          {texts[11]}
        </ScrollRevealSpan>
        <ScrollRevealSpan className="grid-col-lg">{texts[12]}</ScrollRevealSpan>

        <ScrollReveal className="picture grid-col-5">
          <img src={img10} alt="" />
        </ScrollReveal>

        <ScrollRevealSpan className="grid-col-lg">{texts[13]}</ScrollRevealSpan>

        <ScrollReveal className="picture grid-col-sm-6">
          <img src={img11} alt="" />
        </ScrollReveal>

        <ScrollRevealSpan className="grid-col-lg">{texts[14]}</ScrollRevealSpan>

        <ScrollReveal className="picture grid-col-5">
          <img src={img12} alt="" />
          <ScrollRevealSpan className="stars">⁂</ScrollRevealSpan>
        </ScrollReveal>

        <ScrollRevealSpan className="grid-col-lg">{texts[15]}</ScrollRevealSpan>

        <ScrollReveal className="picture grid-col-sm-4">
          <img src={img13} alt="" />
        </ScrollReveal>

        <ScrollReveal className="picture grid-col-sm">
          <img src={img14} alt="" />
        </ScrollReveal>

        <ScrollReveal className="picture grid-col-sm">
          <img src={img15} alt="" />
        </ScrollReveal>

        <ScrollRevealSpan className="grid-col-lg">{texts[16]}</ScrollRevealSpan>

        <ScrollReveal className="picture grid-col-sm-6">
          <img src={img16} alt="" />
        </ScrollReveal>

        <ScrollRevealSpan className="grid-col-lg">{texts[17]}</ScrollRevealSpan>

        <ScrollReveal className="picture grid-col-5">
          <img src={img17} alt="" />
        </ScrollReveal>

        <ScrollRevealSpan className="grid-col-lg">{texts[18]}</ScrollRevealSpan>

        <ScrollReveal className="picture grid-col-sm-8">
          <img src={img18} alt="" />
        </ScrollReveal>
        <ScrollReveal className="picture grid-col-sm">
          <img src={img19} alt="" />
        </ScrollReveal>

        <ScrollRevealSpan className="grid-col-lg">{texts[19]}</ScrollRevealSpan>

        <ScrollReveal className="picture grid-col-sm-4">
          <img src={img20} alt="" />
        </ScrollReveal>

        <ScrollReveal className="picture grid-col-sm">
          <img src={img21} alt="" />
        </ScrollReveal>

        <ScrollReveal className="picture grid-col-sm">
          <img src={img22} alt="" />
        </ScrollReveal>

        <ScrollRevealSpan className="grid-col-lg">{texts[20]}</ScrollRevealSpan>

        <ScrollRevealSpan className="quote">{texts[21]}</ScrollRevealSpan>
      </div>
    </div>
  );
};

export default Chapter;
